import React from 'react'
import {
  fieldKey,
  getCellTotal,
  isCellEdited,
  isCellValid,
  providerField,
} from '../providerSplitHelpers'

export default function ProviderSplitTable({
  verificationType,
  providers,
  portfolios,
  values,
  originalValues,
  canEdit,
  readOnly,
  register,
}) {
  const testId = `provider-split-table-${verificationType.code_key}`
  const cellValues = canEdit ? values : originalValues
  const invalidCount = portfolios.filter(
    (portfolio) =>
      !isCellValid(cellValues?.[fieldKey(verificationType.id, portfolio.id)])
  ).length

  return (
    <div className="box lox-provider-split__card" data-testid={testId}>
      <div className="is-flex is-justify-content-space-between is-align-items-center mb-3">
        <h2 className="title is-5 mb-0 has-text-link">
          {verificationType.name}
        </h2>
        <span
          className="tag is-light is-rounded"
          data-testid={`${testId}-status`}
        >
          {invalidCount === 0
            ? 'All portfolios = 100%'
            : `${invalidCount} portfolio${
                invalidCount === 1 ? '' : 's'
              } not at 100%`}
        </span>
      </div>
      <div className="table-container">
        <table className="table is-bordered is-narrow is-fullwidth lox-provider-split__table">
          <thead>
            <tr>
              <th>Provider</th>
              {portfolios.map((portfolio) => (
                <th key={portfolio.id} className="has-text-centered">
                  {portfolio.name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {providers.map((provider) => (
              <tr key={provider.id}>
                <td className="has-text-weight-semibold">{provider.name}</td>
                {portfolios.map((portfolio) => {
                  const key = fieldKey(verificationType.id, portfolio.id)
                  const field = providerField(provider)
                  return (
                    <td key={portfolio.id} className="has-text-centered">
                      {canEdit ? (
                        <span className="lox-provider-split__input-wrapper">
                          <input
                            className="input is-small lox-provider-split__input"
                            type="number"
                            min={0}
                            max={100}
                            step={1}
                            readOnly={readOnly}
                            data-testid={`${testId}-input-${key}-${field}`}
                            {...register(`${key}.${field}`)}
                          />
                          <span>%</span>
                          {isCellEdited(originalValues, values, key, field) && (
                            <span
                              className="lox-provider-split__edited-dot"
                              data-testid={`${testId}-edited-${key}-${field}`}
                            />
                          )}
                        </span>
                      ) : (
                        <span data-testid={`${testId}-value-${key}-${field}`}>
                          {originalValues?.[key]?.[field]}%
                        </span>
                      )}
                    </td>
                  )
                })}
              </tr>
            ))}
            <tr className="lox-provider-split__total-row">
              <td>TOTAL</td>
              {portfolios.map((portfolio) => {
                const key = fieldKey(verificationType.id, portfolio.id)
                const valid = isCellValid(cellValues?.[key])
                return (
                  <td
                    key={portfolio.id}
                    className={`has-text-centered ${
                      valid ? '' : 'lox-provider-split__total--invalid'
                    }`}
                    data-testid={`${testId}-total-${key}`}
                  >
                    {getCellTotal(cellValues?.[key])}%
                    {!valid && ' · must = 100%'}
                  </td>
                )
              })}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  )
}
